import React from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

const Footer = () => {
    return (
        <footer className="bg-purple-100 backdrop-blur-sm text-gray-800 py-12">
            <div className="container mx-auto px-4 w-[70%]">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {/* Company Section - replacing logo with text */}
                    <div className="flex flex-col border-b-2 md:border-b-0 md:border-r-2 border-gray-300 pb-4 md:pb-0">
                        <div className="flex flex-col items-left mb-4 w-[80%] mx-auto">
                            <h2 className="text-2xl font-bold text-gray-800">DARI INVESTMENT</h2>
                            <p className="text-sm text-gray-600 text-left mt-2">
                                Your trusted partner in delivering world class projects
                            </p>
                        </div>
                    </div>

                    {/* Navigation Section */}
                    <div className="flex flex-col border-b-2 md:border-b-0 md:border-r-2 border-gray-300 pb-4 md:pb-0">
                        <h3 className="text-xl md:text-lg font-semibold mb-4">Quick Links</h3>
                        <nav className="flex flex-col space-y-2">
                            <HashLink smooth to="/#home" className="text-gray-600 hover:text-gray-900 md:text-sm">Home</HashLink>
                            <HashLink smooth to="/#about" className="text-gray-600 hover:text-gray-900 md:text-sm">About</HashLink>
                            <Link to="/projects" className="text-gray-600 hover:text-gray-900 md:text-sm">Projects</Link>
                            <HashLink smooth to="/#contact" className="text-gray-600 hover:text-gray-900 md:text-sm">Contact</HashLink>
                        </nav>
                    </div>

                    {/* Contact Section */}
                    <div className="flex flex-col">
                        <h3 className="text-xl font-semibold mb-4">Contact Us</h3>
                        <div className="space-y-2 text-gray-600">
                            <p>27, Durban Street, Off Ademola Adetokunbo Crescent</p>
                            <p>Wuse II, Abuja</p>
                            <p>Email: admin@dariinvestment.com</p>
                            <p>Phone: +234 803 786 2621</p>
                        </div>
                    </div>
                </div>

                {/* Copyright Section */}
                <div className="border-t border-gray-300 mt-8 pt-4 text-center text-gray-600">
                    <p>&copy; 1990 Dari Investment. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;